import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { EditorProvider, useEditor } from '../../context/EditorContext';
import ResumeCanvas from '../../components/editor/ResumeCanvas';
import EditorSidePanel from '../../components/editor/EditorSidePanel.tsx';

function EditorLayout() {
    const { resumeId } = useParams<{ resumeId: string }>();
    const { loadResume, currentVersion, isSaving, canvasRef, resumeName } = useEditor();

    useEffect(() => {
        if (resumeId) {
            loadResume(resumeId);
        }
    }, [resumeId, loadResume]);

    // ... loading check ...

    return (
        <div className="flex h-screen bg-[#0c0e14] overflow-hidden relative">
            {/* Top Bar with Name & Exit */}
            <div className="absolute top-4 left-4 right-4 z-50 flex justify-between items-start pointer-events-none">
                <div className="pointer-events-auto">
                    <button
                        onClick={() => window.location.href = '/dashboard/resumes'}
                        className="flex items-center gap-2 px-4 py-2 bg-black/50 hover:bg-white/10 text-gray-400 hover:text-white rounded-lg backdrop-blur-sm transition-all border border-white/5 hover:border-white/10"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 12H5M12 19l-7-7 7-7" />
                        </svg>
                        <span className="font-medium text-sm">Exit Editor</span>
                    </button>
                </div>

                {/* Resume Name Display */}
                {resumeName && (
                    <div className="bg-black/50 px-4 py-2 rounded-lg backdrop-blur-sm border border-white/5 text-gray-300 font-medium text-sm pointer-events-auto">
                        {resumeName}
                    </div>
                )}
            </div>

            {/* Main Canvas Area */}
            <div className="flex-1 overflow-y-auto bg-[#1a1c23] p-8 flex justify-center">
                <div className="w-full max-w-[850px]">
                    <ResumeCanvas ref={canvasRef} />
                </div>
            </div>

            {/* Side Panel */}
            <div className="w-[400px] border-l border-white/5 bg-[#0c0e14] flex flex-col">
                <EditorSidePanel />
            </div>

            {/* Save Status Indicator */}
            <div className="fixed bottom-4 left-4 text-xs font-mono text-gray-500 bg-black/50 px-2 py-1 rounded backdrop-blur-sm pointer-events-none">
                {isSaving ? 'Saving...' : 'Saved'}
            </div>
        </div>
    );
}

export default function ResumeEditorPage() {
    return (
        <EditorProvider>
            <EditorLayout />
        </EditorProvider>
    );
}
